import { render, staticRenderFns } from "./JoppdBDetailCompact.vue?vue&type=template&id=1491db21&scoped=true"
import script from "./JoppdBDetailCompact.vue?vue&type=script&lang=js"
export * from "./JoppdBDetailCompact.vue?vue&type=script&lang=js"
import style0 from "./JoppdBDetailCompact.vue?vue&type=style&index=0&id=1491db21&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1491db21",
  null
  
)

export default component.exports